import React, { useState, useEffect, useContext } from "react";

import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { useParams, Link, useHistory, useLocation } from "react-router-dom";
import { BsCreditCard } from "react-icons/bs";
import { FaPiggyBank } from "react-icons/fa";
import { BsExclamationCircle } from "react-icons/bs";
import { MdContentCopy } from "react-icons/md";
import { CoinContext } from "../../contexts/CoinContext";
import * as Sentry from "@sentry/react";
import { REACT_APP_PROD_URL } from "../../services/configs";
import useResizer from "../../services/useResizer";
import Icon from "../../fontIcons/icon";
import styled from "styled-components";
import { useSelector } from "react-redux";
import qs from "query-string";
import useSWR from "swr";
import fetcher from "../../api/swr_fetcher";
import { Divider } from "@material-ui/core";
import INRBalanceCard from "../INRDeposit/INRBalanceCard";
import { copyTextAndSendToApp } from "../../services/appMethods";

export default function InstantDeposit(props) {
  const isMobile = useResizer();
  const classes = useStyles();
  const { handleClickAlert, bannedTimeout } = useContext(CoinContext);

  const [name, setName] = useState("Loading...");
  const [accountNum, setAccountNum] = useState("Loading...");
  const [ifsc, setIfsc] = useState("Loading...");
  const [remark, setRemark] = useState("Loading...");
  const [limit, setLimit] = useState({
    min: 500,
    max: 2000000,
  });

  let history = useHistory();

  const { data, error } = useSWR(`/v1/transfers/deposit_info`, fetcher, {
    revalidateOnFocus: false,
    shouldRetryOnError: false,
  });
  const { data: limitData } = useSWR(`/v1/inrConfig`, fetcher, {
    revalidateOnFocus: false,
    shouldRetryOnError: false,
  });

  useEffect(() => {
    if (data) generateData(data);
    if (limitData) generateLimitData(limitData);
  }, [data, limitData]);
  function generateData(data) {
    setName(data.udf2);
    setAccountNum(data.accountNumber);
    setIfsc(data.ifsc);
    setRemark(data.udf1);
  }
  function generateLimitData(data) {
    setLimit({
      min: data.minWithdraw,
      max: data.maxWithdraw,
    });
  }

  useEffect(() => {
    if (error?.status === 401) {
      bannedTimeout("timeout");
    } else if (error?.status === 403) {
      bannedTimeout("banned");
    }
  }, [error]);

  return (
    <div className={classes.container}>
      <h1 className="mb-3">Instant Deposit</h1>
      <p className="font-light mb-5">
        <span
          className="underline cursor-pointer"
          onClick={() => {
            if (isMobile) {
              history.push(`/wallet/inr`);
            } else {
              history.push(`/wallet/inr`);
            }
          }}
        >
          Wallet
        </span>{" "}
        {">"}{" "}
        <span
          className="underline cursor-pointer"
          onClick={() => {
            history.push(`/inr/deposit`);
          }}
        >
          Deposit INR
        </span>{" "}
        > <span style={{ color: "#3AC4AB" }}>Instant Deposit</span>
      </p>
      <div className={classes.gridContainer}>
        <INRBalanceCard></INRBalanceCard>
        <Divider />
        <div className={classes.subContainer}>
          <p style={{ color: "#92989B" }}>
            <span style={{ color: "red", fontWeight: "bold" }}>
              {"Note:" + "\xa0"}
            </span>{" "}
            The INR deposit amount should be greater than ₹{limit.min}.
          </p>
        </div>
        <Divider />
        <div className={classes.subContainer}>
          <div className={classes.flexContainer}>
            <FaPiggyBank style={{ fontSize: "20px", color: "#3AC4AB" }} />
            <p
              style={{
                color: "#3AC4AB",
                fontSize: "16px",
                fontWeight: "bold",
                marginLeft: "15px",
              }}
            >
              Account details for Instant Deposit
            </p>
          </div>
          <div className={classes.flexContainer} style={{ marginTop: "5px" }}>
            <p className={classes.ptitle}>Beneficiary Name</p>
            <p className={`${classes.pvalue} ml-3`}>Defacto Technologies</p>
            <div className={classes.grow} />
            <MdContentCopy
              className={classes.copyIcon}
              onClick={() => {
                navigator.clipboard.writeText("Defacto Technologies");
                copyTextAndSendToApp("Defacto Technologies");

                handleClickAlert("success", "Copied!");
              }}
            />
          </div>
          <div className={classes.flexContainer} style={{ marginTop: "5px" }}>
            <p className={classes.ptitle}>Account Number</p>
            <p className={`${classes.pvalue} ml-3`}>{accountNum}</p>
            <div className={classes.grow} />
            <MdContentCopy
              className={classes.copyIcon}
              onClick={() => {
                navigator.clipboard.writeText(accountNum);
                copyTextAndSendToApp(accountNum);

                handleClickAlert("success", "Copied!");
              }}
            />
          </div>
          <div className={classes.flexContainer} style={{ marginTop: "5px" }}>
            <p className={classes.ptitle}>IFSC</p>
            <p className={`${classes.pvalue} ml-3`}>{ifsc}</p>
            <div className={classes.grow} />
            <MdContentCopy
              className={classes.copyIcon}
              onClick={() => {
                navigator.clipboard.writeText(ifsc);
                copyTextAndSendToApp(ifsc);

                handleClickAlert("success", "Copied!");
              }}
            />
          </div>
          <div className={classes.flexContainer} style={{ marginTop: "5px" }}>
            <p className={classes.ptitle}>Remark</p>
            <p className={`${classes.pvalue} ml-3`}>{remark}</p>
            <div className={classes.grow} />
            <MdContentCopy
              className={classes.copyIcon}
              onClick={() => {
                navigator.clipboard.writeText(remark);
                copyTextAndSendToApp(remark);

                handleClickAlert("success", "Copied!");
              }}
            />
          </div>
        </div>
        <Divider />
        <div className={classes.subContainer}>
          <div
            className={classes.flexContainer}
            style={{
              borderBottomStyle: "solid",
              paddingBottom: "5px",
              borderColor: "red",
              borderWidth: "2px",
            }}
          >
            <BsExclamationCircle style={{ fontSize: "20px", color: "red" }} />
            <p
              style={{
                color: "red",
                fontWeight: "bold",
                marginLeft: "15px",
              }}
            >
              Information
            </p>
          </div>
          <ol
            style={{
              marginTop: "10px",
              marginLeft: "25px",
              color: "#9fa1a0",
            }}
          >
            <li>Zero Fee Deposits.</li>
            <li>Use only registered bank accounts for Deposits.</li>
            <li>
              Deposit only to the account details visible on your INR deposit
              screen as all users have a different Virtual account number.
            </li>
          </ol>
        </div>
      </div>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  container: {
    flexGrow: 1,
    [theme.breakpoints.up("lg")]: {
      width: "52%",
    },
    marginLeft: "auto",
    marginRight: "auto",
  },
  grow: {
    flexGrow: 1,
  },
  link: {
    fontWeight: "bold",
    color: theme.palette.primary.text,
    paddingLeft: "10px",
    "&:hover": {
      cursor: "pointer",
      textDecoration: "underline",
    },
  },
  gridContainer: {
    background: theme.palette.type === "dark" ? "#151828" : "white",
    paddingTop: "3px",
  },
  subContainer: {
    marginTop: "15px",
    marginLeft: "20px",
    paddingBottom: "15px",
    marginRight: "15px",
  },
  flexContainer: {
    display: "flex",
    alignItems: "center",
  },
  ptitle: {
    width: "35%",
    color: "#9fa1a0",
    fontSize: "14px",
    // marginLeft: "35px",
  },
  pvalue: {
    fontSize: "14px",
    fontWeight: "bold",
    color: "#92989B",
  },
  copyIcon: {
    fontSize: "20px",
    color: theme.palette.primary.main,
    "&:hover": {
      cursor: "pointer",
    },
  },
}));
